import React, { useRef } from 'react';
import useFadeIn from '@src/hooks/useFadeIn';
import styles from './index.module.scss';
import SectionTitle from '@src/components/SectionTitle';
import SectionContent from '@src/components/SectionContent';
import Button from '@src/components/Button';
import { GithubBaseLink } from "@src/constant/navLinks";

const title = "Verified data, trusted computation";
const contentFirst =
  "Primus' Data Verification and Computation (DVC) network ensures that off-chain data is accurate and authentic before it's used in any computation.";
const contentSecond =
  "By verifying data at the source and handing it off to external trustless computing platforms like zkVMs for processing, Primus guarantees trust and integrity without handling the business logic itself.";

export default () => {
    const ref = useRef(null);
    const [visible] = useFadeIn(ref);
    return (
      <div className={styles.root}>
        <div className={styles.inner}>
          <div className={styles.wrapper}>
            <SectionTitle
              transition
              visible={visible}
              ref={ref}
              className={styles.title}
            >
              {title}
            </SectionTitle>
            <div className={styles.contentWrap}>
              <SectionContent
                transition
                visible={visible}
                className={styles.content}
              >
                <div>{contentFirst}</div>
                <div>{contentSecond}</div>
              </SectionContent>
            </div>
            <div className={styles.footer}>
            <Button link={`${GithubBaseLink}`} className={styles.btn} isDark>
                Start Building
              </Button>
            </div>
          </div>
          <div className={styles.img} />
        </div>
      </div>
    );
};